"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MessageFormatFull_1 = require("./components/MessageFormatFull");
var isMessageFormatOptionDirty_1 = require("./utils/isMessageFormatOptionDirty");
var discardMessageFormatOption_1 = require("./actions/discardMessageFormatOption");
var saveMessageFormatOption_1 = require("./actions/saveMessageFormatOption");
var MessageFormatOption = {
    key: 'messageFormat',
    titleStringKey: 'optionTitle_messageFormat',
    searchTermsStringKey: 'optionTitle_messageFormat',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageFormatFull_1.default, null); },
        isDirty: isMessageFormatOptionDirty_1.default,
        onSave: saveMessageFormatOption_1.default,
        onDiscard: discardMessageFormatOption_1.default,
    },
};
exports.default = MessageFormatOption;
//# sourceMappingURL=MessageFormatOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/MessageFormatOption.js
// module id = 5146
// module chunks = 2